export const ORDER_MOVING_PACKAGES = {
  MUTATIONS: {
    SET_ACTIVE_ID: 'order moving packages set active id',
    SET_LIST: 'order moving packages set list',
    SET_MOVE_PRICE: 'order moving packages set move price'
  },
  ACTIONS: {
    GET_LIST: 'order moving packages fetch list'
  },
  GETTERS: {
    LIST: 'order moving packages get list',
    ACTIVE_ID: 'order moving packages get active id',
    ACTIVE_ITEM: 'order moving packages get active item',
    MOVE_PRICE: 'order moving packages get move price'
  }
}
